import { FileUploadState } from './FileUploadState';
import { getFileExtensionIconClass } from './utils';

export default function FileUploadSubmissionError({
    setFileUploadState,
    selectedFiles,
    setSelectedFiles = () => { },
    displayParameters
}) {
    const showAlert = displayParameters.showAlert !== false;

    const removeFile = (selectedFile) => {
        setSelectedFiles(selectedFiles.filter(file => file !== selectedFile));
        setFileUploadState(FileUploadState.Upload);
    };

    return (
        <>
            {displayParameters.customAlertContent}
            {showAlert && displayParameters.submissionErrorAlertContent && (
                <div className="alert margin-top" id='file-upload-error-alert'>
                    <div className="alert--high-importance">
                        <span className="icon-alert"></span>
                        <ul className="alert-list">
                            {displayParameters.submissionErrorAlertContent}
                        </ul>
                    </div>
                </div>
            )}

            <div className={selectedFiles.length > 0 ? "drop doc-status-wrapper" : "drop drop-zone"}>
                <div className="font--center padding-top">
                    <gds-icon icon-type='cancel' size="large" />
                    {displayParameters.errorTopText}
                </div>

                {selectedFiles.length > 0 &&
                    <div>
                        <div className="doc-upload container-padding">
                            <div>
                                {displayParameters.errorHeader}
                            </div>
                            {selectedFiles.map((file) => (
                                <div className="margin-top" key={`${file.name}-selected-file-container`}>
                                    <div className="doc-upload-files">
                                        <span className={`img-icon ${getFileExtensionIconClass(file.name)} hidden-sm hidden-md`} />
                                        <div>{file?.name}</div>
                                        <a>
                                            <span
                                                className="geico-icon geico-icon--actionable geico-icon--small icon-trash"
                                                onClick={() => removeFile(file, `${file.name}-selected-file-container`)}
                                            />
                                        </a>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                }
            </div>
        </>
    );
};

function formatBytes(kilobytes, decimals = 2) {
    if (!+kilobytes) return '0 KB'

    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ['KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

    const i = Math.floor(Math.log(kilobytes) / Math.log(k))

    return `${parseFloat((kilobytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
}
